import React from 'react';
import {
  ADMIN_PROSPECT_RESPONSE_INTENTS,
  adminProspectCampaignDetailPath,
  adminProspectResponseIntentLabel,
  formatAdminDate,
} from './adminProspectDisplay';
import {
  ProspectCampaignLink,
  ProspectOwnerResponseCard,
  ProspectOwnerResponseField,
} from './ProspectOwnerResponseShared';

export default function ProspectPublicResponseSummary({
  summary,
  language,
  t,
  hideTitle = false,
  embedded = false,
}) {
  if (!summary) {
    return (
      <div id="prospect-public-response">
        <ProspectOwnerResponseCard
          title={t('admin.prospection.section.responseSummary')}
          hideTitle={hideTitle}
          embedded={embedded}
        >
          <p className="text-sm text-slate-600">{t('admin.prospection.ownerResponse.summary.empty')}</p>
        </ProspectOwnerResponseCard>
      </div>
    );
  }

  const received = ADMIN_PROSPECT_RESPONSE_INTENTS.map((intent) => {
    const entry = summary.receivedIntents?.[intent];
    if (!entry || entry.status !== 'received') return null;
    const label = adminProspectResponseIntentLabel(intent, t);
    return label ? { intent, label } : null;
  }).filter(Boolean);
  const lastIntent = adminProspectResponseIntentLabel(summary.lastResponseIntent, t);
  const first = formatAdminDate(summary.firstRespondedAt, language);
  const last = formatAdminDate(summary.lastRespondedAt, language);
  const campaignPath = adminProspectCampaignDetailPath(summary.lastCampaignId);

  return (
    <div id="prospect-public-response">
      <ProspectOwnerResponseCard
        title={t('admin.prospection.section.responseSummary')}
        hideTitle={hideTitle}
        embedded={embedded}
      >
        {received.length ? (
          <section aria-labelledby="prospect-received-intents">
            <h3
              id="prospect-received-intents"
              className="text-xs font-medium uppercase tracking-wide text-slate-500"
            >
              {t('admin.prospection.ownerResponse.summary.receivedIntents')}
            </h3>
            <ul className="mt-2 flex flex-wrap gap-2">
              {received.map((item) => (
                <li
                  key={item.intent}
                  className="rounded-full bg-violet-50 px-2 py-0.5 text-xs font-semibold text-violet-900 ring-1 ring-violet-200"
                >
                  {item.label}
                </li>
              ))}
            </ul>
          </section>
        ) : null}
        <dl className="grid gap-3 sm:grid-cols-2">
          {first && first !== '—' ? (
            <ProspectOwnerResponseField label={t('admin.prospection.ownerResponse.summary.firstRespondedAt')}>
              {first}
            </ProspectOwnerResponseField>
          ) : null}
          {last && last !== '—' ? (
            <ProspectOwnerResponseField label={t('admin.prospection.ownerResponse.summary.lastRespondedAt')}>
              {last}
            </ProspectOwnerResponseField>
          ) : null}
          {lastIntent ? (
            <ProspectOwnerResponseField label={t('admin.prospection.ownerResponse.summary.lastIntent')}>
              {lastIntent}
            </ProspectOwnerResponseField>
          ) : null}
          {campaignPath ? (
            <ProspectOwnerResponseField label={t('admin.prospection.ownerResponse.summary.campaign')}>
              <ProspectCampaignLink campaignId={summary.lastCampaignId} t={t} />
            </ProspectOwnerResponseField>
          ) : null}
        </dl>
      </ProspectOwnerResponseCard>
    </div>
  );
}
